import React, { useState, useRef, useEffect } from "react";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  InputGroup,
  Card,
  Spinner,
} from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { CiMail } from "react-icons/ci";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Success from "../../../components/Success";
import Footer from "../../../components/Footer";
import { useAlerts } from "../../../context/AlertContext";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import api from "../../../utils/helper";
import { URLS } from "../../../utils/URL";
import { BadgesComponent } from "../../../components/AddBadge";
import { useIDsContext } from "../../../context/IDsContext";
import { useAuth } from "../../../context/AuthContext";

const AddTeacher = () => {
  const location = useLocation();
  const { userID } = useAuth();
  console.log(userID, "userID");
  const { vendorID, collegeID, vendorName } = useIDsContext();
  console.log("selectedVendor:", vendorID, collegeID, vendorName);
  const teacher = location.state?.teacher;
  const isEdit = location.state?.isEdit;
  const navigate = useNavigate();
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(
    isEdit ? URLS.IMG_URL + teacher?.profile_img : null
  );
  const [dataToNavigate, setDataToNavigate] = useState({});
  const [signatureFile, setSignatureFile] = useState(null);
  const [signaturePreview, setSignaturePreview] = useState(
    isEdit ? URLS.IMG_URL + teacher?.signature_img : null
  ); // for image preview
  const signatureInputRef = useRef(null); // to trigger input programmatically
  const { showSuccess, showError } = useAlerts();
  const fileInputRef = useRef(null);

  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");

  // React Hook Form setup
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      vendor: vendorID,
      firstName: isEdit ? teacher.firstname : "",
      lastName: isEdit ? teacher.lastname : "",
      email: isEdit ? teacher.email : "",
      password: "123456789",
      college: isEdit ? teacher.college._id : "",
      sendInvite: true,
      about: isEdit ? teacher.about : "",
      subjects: isEdit ? teacher.subjects : [],
    },
  });

  useEffect(() => {
    if (isEdit && teacher?.subjects?.length > 0) {
      setTags(teacher.subjects);
    }
  }, [isEdit, teacher]);

  const { data, isLoading, error } = useQuery(
    ["colleges", userID],
    () => api.get(`/super-admin/colleges?vendorId=${userID}`), // Fixed template string
    {
      onError: (err) => {
        console.error(
          "Error fetching colleges:",
          err.response?.data?.message || err.message
        );
      },
    }
  );

  const teacherMutation = useMutation(
    isEdit
      ? (vendorsData) =>
          api.put(`/super-admin/teachers/${teacher._id}`, vendorsData)
      : (vendorData) => api.post("/super-admin/teachers", vendorData),
    {
      onSuccess: (response) => {
        showSuccess(response.data?.message || "Teacher added successfully!");
        console.log("Teacher added successfully!", response);
        console.log("Teacher updated successfully!", response);

        setTimeout(() => {
          handleCancel();
        }, 2000);
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Failed to add Teacher: ");
        console.log("Failed to add Teacher: " + error.message);
      },
    }
  );

  const logoMutation = useMutation(
    ({ formData }) => api.upload("/upload", formData, "upload"),
    {
      onSuccess: (response, variables) => {
        const updatedFormInputs = {
          ...variables.formInputs,
          profile_img: response?.data?.data?.url,
        };
        teacherMutation.mutate(updatedFormInputs);
        const updatedSignatureFormInputs = {
          ...variables.formInputs,
          signature_img: response?.data?.data?.url,
        };
        teacherMutation.mutate(updatedSignatureFormInputs);
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Error uploading file:");
        console.error("Error uploading file:", error);
      },
    }
  );

  const handleDivClick = () => {
    fileInputRef.current.click(); // Trigger file input click
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSignatureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSignatureFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setSignaturePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (isEdit && teacher) {
      // Other form value initialization logic
      if (teacher.signature_img) {
        setSignaturePreview(URLS.IMG_URL + teacher.signature_img); // Set thumbnail preview if in edit mode
      }
    }
  }, [isEdit, teacher]);

  // const onSubmit = (data) => {
  //   console.log(data, "daa");

  //   const formInputs = {
  //     vendor: vendorID,
  //     college: data.college,
  //     firstname: data.firstName,
  //     lastname: data.lastName,
  //     email: data.email,
  //     password: data.password,
  //     sendInvite: data.sendInvite,
  //     about: data.about,
  //     subjects: tags,
  //   };
  //   console.log(formInputs, "555");

  //   // For edit mode with existing image that's not being changed
  //   if (
  //     isEdit &&
  //     !logoFile &&
  //     !signatureFile &&
  //     signaturePreview &&
  //     logoPreview
  //   ) {
  //     // Extract just the filename from the full URL path
  //     const existingImagePath = teacher?.profile_img;
  //     formInputs.profile_img = existingImagePath;
  //     teacherMutation.mutate(formInputs);

  //     const existingSignatureImagePath = teacher?.signature_img;
  //     formInputs.signature_img = existingSignatureImagePath;
  //     teacherMutation.mutate(formInputs);
  //   }
  //   // For new image upload (both in create and edit mode)
  //   else if (signatureFile) {
  //     const formData = new FormData();
  //     formData.append("file", signatureFile);
  //     formData.append("courseName", "vendor");
  //     formData.append("moduleName", "vendor");
  //     console.log(formInputs, "inpur");

  //     logoMutation.mutate({ formData, formInputs });
  //   } else if (logoFile) {
  //     const formData = new FormData();
  //     formData.append("file", logoFile);
  //     formData.append("courseName", "vendor");
  //     formData.append("moduleName", "vendor");
  //     console.log(formInputs, "inpur");

  //     logoMutation.mutate({ formData, formInputs });
  //   }
  //   // For cases with no image (create mode without image)
  //   else {
  //     teacherMutation.mutate(formInputs);
  //   }
  // };

  const handleCancel = () => {
    reset();
    navigate("/vendor/teacher-list", { state: { vendorID: userID } });
  };

  const handleTagInput = (e) => {
    if (e.key === "Enter" && tagInput.trim()) {
      e.preventDefault();
      if (!tags.includes(tagInput.trim())) {
        setTags([...tags, tagInput.trim()]);
        setTagInput("");
      }
    }
  };

  const removeTag = (tag) => {
    setTags(tags.filter((t) => t !== tag));
  };

  // Update the onSubmit function to handle both image uploads
  const onSubmit = async (data) => {
    try {
      const formInputs = {
        vendor: vendorID,
        college: data.college,
        firstname: data.firstName,
        lastname: data.lastName,
        email: data.email,
        password: data.password,
        sendInvite: data.sendInvite,
        about: data.about,
        subjects: tags,
      };

      // Retain existing URLs in edit mode if no new files are uploaded
      if (isEdit) {
        if (!logoFile && teacher.profile_img) {
          formInputs.profile_img = teacher.profile_img;
        }
        if (!signatureFile && teacher.signature_img) {
          formInputs.signature_img = teacher.signature_img;
        }
      }

      // Upload cover image if a new file is provided
      if (logoFile) {
        formInputs.profile_img = await uploadFile(logoFile);
      }

      // Upload thumbnail image if a new file is provided
      if (signatureFile) {
        formInputs.signature_img = await uploadFile(signatureFile);
      }

      // Submit the course data
      if (isEdit) {
        await teacherMutation.mutateAsync(formInputs);
        showSuccess("Teacher updated successfully!");
        navigate("/vendor/teacher-list", { state: { vendorID: userID } });
      } else {
        const response = await teacherMutation.mutateAsync(formInputs);
        showSuccess("Teacher added successfully!");
        setDataToNavigate(response.data?.data);
        reset();
        setTags([]);
      }
    } catch (error) {
      showError(
        error.response?.data?.message ||
          "Failed to save course. Please try again."
      );
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("courseName", "course");
    formData.append("moduleName", "course");
    const response = await api.upload("/upload", formData, "upload");
    return response.data.data.url;
  };

  return (
    <>
      <DefaultLayout>
        <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
          <h2 className="heading mb-0 px-3">
            {/* <Link to="/vendor/teachers" className="linkHref"> */}
            <span className="linkHref">{vendorName}</span>
            {/* </Link>{" "} */}
            <Link to="/vendor/teacher-list" className="linkHref">
              <span className="linkHref">
                {" "}
                <FaArrowRight /> Teachers
              </span>
            </Link>{" "}
            <span className=" text-light fw-bold">
              {" "}
              <FaArrowRight className="mx-1" /> {isEdit ? "Edit " : "Add New"}
            </span>
          </h2>
        </div>

        <Container
          fluid
          className="main-container mt-0 mt-md-4 ps-auto ps-md-0"
        >
          <Card className="form-card">
            {/* Header Section */}
            <Card.Header className="heading d-none d-lg-block">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-2 align-items-center">
                  <h2 className="text-muted venhead mb-0">
                    {/* <Link to="/vendor/teachers" className="linkHref"> */}
                    <span className="linkHref">{vendorName}</span>
                    {/* </Link>{" "} */}
                    <Link to="/vendor/teacher-list" className="linkHref">
                      <span>
                        {" "}
                        <FaArrowRight /> Teachers
                      </span>
                    </Link>{" "}
                    <span className="venhead fw-bold">
                      {" "}
                      <FaArrowRight /> {isEdit ? "Edit " : "Add New"}
                    </span>
                  </h2>
                </div>
                <div>
                  <Button
                    variant="outline-secondary"
                    className="me-2 btn-sec"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="#60B1FF"
                    className="btn-sec"
                    onClick={handleSubmit(onSubmit)}
                    disabled={
                      teacherMutation.isLoading || logoMutation.isLoading
                    }
                  >
                    {teacherMutation.isLoading ||
                      (logoMutation.isLoading && <Spinner size="sm" />)}
                    Save & Invite
                  </Button>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="mobile-form">
              <Row className="mb-3">
                <Col md={3} className="px-4 py-2 p-md-2">
                  <h3 className="vendorDetails">Personal Details</h3>
                  <p className="basicInfo mb-0">
                    {isEdit ? "Update teacher" : "Add teacher"}'s basic info
                  </p>
                </Col>
                <Col md={9} className="contentdiv">
                  <Form className="p-2 formMain">
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            First name <span className="text-danger">*</span>
                          </Form.Label>
                          <Controller
                            name="firstName"
                            control={control}
                            rules={{ required: "First name is required" }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type="text"
                                placeholder="First name"
                                isInvalid={!!errors.firstName}
                              />
                            )}
                          />
                          {errors.firstName && (
                            <Form.Control.Feedback type="invalid">
                              {errors.firstName.message}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Last name <span className="text-danger">*</span>
                          </Form.Label>
                          <Controller
                            name="lastName"
                            control={control}
                            rules={{ required: "Last name is required" }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type="text"
                                placeholder="Last name"
                                isInvalid={!!errors.lastName}
                              />
                            )}
                          />
                          {errors.lastName && (
                            <Form.Control.Feedback type="invalid">
                              {errors.lastName.message}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        Email <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="email"
                        control={control}
                        rules={{
                          required: "Email is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        }}
                        render={({ field }) => (
                          <InputGroup>
                            <InputGroup.Text className="bg-transparent">
                              <CiMail />
                            </InputGroup.Text>
                            <Form.Control
                              {...field}
                              type="email"
                              placeholder="Enter email"
                              isInvalid={!!errors.email}
                              disabled={isEdit} // 👈 disable when editing
                            />
                            {errors.email && (
                              <Form.Control.Feedback type="invalid">
                                {errors.email.message}
                              </Form.Control.Feedback>
                            )}
                          </InputGroup>
                        )}
                      />
                    </Form.Group>

                    {/* {!isEdit && (
                      <Form.Group className="mb-3">
                        <Controller
                          name="sendInvite"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <Form.Check
                              type="switch"
                              id="invite-email-switch"
                              label="Send Invite Email"
                              className="checktoggle"
                              checked={value}
                              onChange={(e) => onChange(e.target.checked)}
                            />
                          )}
                        />
                        <Form.Text className="text-muted">
                          An invitation will be sent to the teacher with login
                          instructions & password.
                        </Form.Text>
                      </Form.Group>
                    )} */}

                    {/* Upload Logo */}
                    <Form.Group className="mb-3 d-flex justify-content-between uploadProfile">
                      <div className="p-con d-flex gap-4 p-2 w-50">
                        <div
                          className="text-center w-100"
                          onClick={() => signatureInputRef?.current?.click()}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={signaturePreview || "/images/uploadIcon.png"}
                            className="icon-upload"
                            alt="Upload"
                          />
                          <p className="upload-text mb-0">
                            <span>Click to upload</span> or drag and drop
                          </p>
                          <p className="mb-0">Signature Image</p>
                          <p className="text-muted upload-text-small mb-0">
                            SVG, PNG, JPG or GIF (max. 400x400px)
                          </p>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            className="d-none"
                            ref={signatureInputRef}
                            onChange={handleSignatureChange}
                          />
                        </div>
                      </div>
                      <div className="p-con d-flex gap-4 p-2 w-50">
                        <div>
                          <img src={logoPreview} className="profile-holder" />
                        </div>
                        <div
                          className="p-con d-flex gap-4 p-2 w-100"
                          onClick={handleDivClick}
                        >
                          <div className="text-center w-100">
                            <img
                              src="/images/uploadIcon.png"
                              className="icon-upload"
                            />
                            <p className="upload-text mb-0">
                              <span>Click to upload</span> or drag and drop
                            </p>
                            <p className="mb-0">Profile Image</p>
                            <p className="text-muted upload-text-small mb-0">
                              SVG, PNG, JPG or GIF (max. 800x400px)
                            </p>
                            <Form.Control
                              type="file"
                              accept="image/*"
                              className="d-none"
                              ref={fileInputRef}
                              onChange={handleLogoChange}
                            />
                          </div>
                        </div>
                      </div>
                    </Form.Group>

                    {/* College Name */}
                    <Form.Group className="mb-3">
                      <Form.Label className="drpvendor">
                        College <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="college"
                        control={control}
                        rules={{ required: "college is required" }}
                        render={({ field }) => (
                          <>
                            <Form.Select
                              {...field}
                              isInvalid={!!errors.college}
                              disabled={isLoading}
                            >
                              <option value="">Select a college</option>
                              {data?.data?.data?.colleges?.map((college) => (
                                <option key={college._id} value={college._id}>
                                  {college.name}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.college?.message}
                            </Form.Control.Feedback>
                          </>
                        )}
                      />
                    </Form.Group>
                  </Form>
                </Col>
              </Row>

              {/* Vendor Details */}
              <Row>
                <Col md={3} className="px-4 py-2 p-md-2">
                  <h3 className="vendorDetails">Additional Details</h3>
                  <p className="basicInfo">Additional profile info</p>
                </Col>
                <Col md={9} className="contentdiv">
                  <Form className="p-2 formMain">
                    {/* Vendor Name */}
                    <Form.Group className="mb-3">
                      <Form.Label>
                        About <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="about"
                        control={control}
                        rules={{
                          required: "About section is required",
                          minLength: {
                            value: 10,
                            message: "Must be at least 10 characters",
                          },
                          maxLength: {
                            value: 500,
                            message: "Cannot exceed 500 characters",
                          },
                        }}
                        render={({ field }) => (
                          <Form.Control as="textarea" rows={3} {...field} />
                        )}
                      />
                      {errors.about && (
                        <p className="text-danger">{errors.about.message}</p>
                      )}
                    </Form.Group>

                    {/* Subjects Name */}
                    <Form.Group className="mb-3" controlId="multiSelect">
                      <Form.Label>
                        Subjects <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        control={control}
                        type="text"
                        placeholder="Enter Subjects"
                        value={tagInput}
                        onChange={(e) => setTagInput(e.target.value)}
                        onKeyDown={handleTagInput}
                      />
                      <div className="mt-2">
                        {/* {tags.map((tag, index) => (
                          <Badge
                            key={index}
                            pill
                            bg="primary"
                            className="me-2 mb-2"
                          >
                            {tag}{" "}
                            <span
                              style={{ cursor: "pointer", marginLeft: "5px" }}
                              onClick={() => removeTag(tag)}
                            >
                              &times;
                            </span>
                          </Badge>
                        ))} */}

                        <BadgesComponent badges={tags} removeTag={removeTag} />
                      </div>
                    </Form.Group>
                    <div className="d-flex justify-content-end d-lg-none">
                      <Button
                        variant="outline-secondary"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="#60B1FF"
                        className="ms-2 "
                        onClick={handleSubmit(onSubmit)}
                        disabled={
                          teacherMutation.isLoading || logoMutation.isLoading
                        }
                      >
                        {teacherMutation.isLoading ||
                          (logoMutation.isLoading && <Spinner size="sm" />)}
                        Save & Invite
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
              {/* </Row> */}
            </Card.Body>
          </Card>
        </Container>
        <div className="d-none d-lg-block">
          <Footer />
        </div>
      </DefaultLayout>
    </>
  );
};

export default AddTeacher;
